import useTranslation from 'next-translate/useTranslation';

import type { WelcomeModalHeaderType } from '~/domains/common/components/WelcomeModal/WelcomeModalHeader';
import { Routes } from '~/domains/common/constants/routes';

import OnboardingWidget from '../OnboardingWidget';

export function EoIntro({
  onCacClick,
  onClose,
  brand,
  isFullScreen,
  isWide,
}: {
  onCacClick: () => void;
  onClose: () => void;
  brand: WelcomeModalHeaderType;
  isFullScreen?: boolean;
  isWide?: boolean;
}) {
  const { t } = useTranslation('commissioner');

  const handleSecondaryButtonClick = () => {
    window.open(Routes.helpCenterCommissioner(), '_blank');
  };

  return (
    <OnboardingWidget
      subTitle={t('onboardingWidget.eoIntro.subTitle')}
      title={t('onboardingWidget.eoIntro.title')}
      description={t('onboardingWidget.eoIntro.description')}
      eoBrand={brand}
      primaryButtonText={t('onboardingWidget.eoIntro.primaryButtonText')}
      secondaryButtonText={t('onboardingWidget.eoIntro.secondaryButtonText')}
      onPrimaryButtonClick={onCacClick}
      onSecondaryButtonClick={handleSecondaryButtonClick}
      onClose={onClose}
      isFullScreen={isFullScreen}
      isWide={isWide}
    />
  );
}
